<section class="about-section" id="about">
  <div class="section-container">
    <div class="about-content">
      <div class="about-text">
        <div class="text-header">
          <div class="header-badge">
            <span class="badge-icon">🎯</span>
            <span class="badge-text">About Tenjah School</span>
          </div>
          <h2 class="section-title">Welcome to Tunisia's Leading Digital School</h2>
          <p class="section-description">
            At Tenjah School, we're not just using technology - we ARE the future of education.
            Join thousands of students who are already transforming their learning journey with us.
          </p>
        </div>
        <div class="about-highlights">
          <div class="highlight-card" *ngFor="let highlight of aboutHighlights; let i = index">
            <div class="highlight-icon-wrapper">
              <span class="highlight-icon">{{ highlight.icon }}</span>
            </div>
            <div class="highlight-content">
              <h3 class="highlight-title">{{ highlight.title }}</h3>
              <p class="highlight-description">{{ highlight.description }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="about-visual">
        <div class="visual-container">
          <div class="floating-elements">
            <div class="floating-icon icon-1">📚</div>
            <div class="floating-icon icon-2">🎓</div>
            <div class="floating-icon icon-3">💡</div>
            <div class="floating-icon icon-4">🌟</div>
          </div>
          <div class="central-graphic">
            <div class="graphic-circle"></div>
            <div class="graphic-text">
              <span class="main-text">Excellence</span>
              <span class="sub-text">in Education</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>